<template>
  <div
    class="forfettario-welcome-card bg-hero-primary smartrate-card border-radius d-block border-0 shadow-none pb-0"
  >
    <div class="smartrate-card-content px-4 pt-3 pb-5">
      <div class="row">
        <div class="col-md-7">
          <div class="content">
            <h1 class="mb-0 fw-normal text-white">{{ t('ff.welcome.message_line1_part1', 'La tua') }} <span class="text-danger-div">{{ t('ff.welcome.message_line1_part2', 'rata ideale') }}</span> {{ t('ff.welcome.message_line1_part3', 'è solo l\'inizio del viaggio.') }}</h1>
           <span class="d-block fw-medium"> 
              {{ t('ff.welcome.message_line2', 'Usa il nostro tool per fare il primo passo verso un futuro in cui le tasse si gestiscono in modo più smart.') }}
            </span>
          </div>
        </div>
        <div class="col-md-5 d-none d-md-block">
          <div class="image" style="position: relative;">
            <img src="@/assets/images/Calcolatrice3D.png" alt="Calcolatrice 3D" class="calculator-image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { t } from '@/utils/i18nHelper';

export default defineComponent({
  name: "WelcomeForfettario",
  setup() {
    return {
      t,
    };
  },
});
</script>

<style lang="scss" scoped>
.forfettario-welcome-card {
  border-radius: 5px;

  .smartrate-card-content {
    .content {
      padding-top: 20px;

      span {
        color: #c2cdff;
        margin-bottom: 5px;
      }
      h1 {
        font-size: 28px;

        strong {
          font-weight: 900;
        }
      }
    }
    .image {
      text-align: end;
      
      .calculator-image {
        width: auto;
        max-height: 120px;
        transform: scale(2.5);
        padding-right: 50px;
        transition: all 0.3s ease;
      }
    }
  }
}
.sa-stats {
  margin: {
    top: -25px;
    left: 25px;
    right: 25px;
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .forfettario-welcome-card {
    .smartrate-card-content {
      .content {
        padding-top: 0;
        text-align: center;

        h1 {
          font-size: 24px;
        }
      }
      .image {
        text-align: center;
        margin-top: 17px;
      }
    }
  }
  .sa-stats {
    margin: {
      left: 0;
      right: 0;
      top: 25px;
    }
  }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .forfettario-welcome-card {
    .smartrate-card-content {
      .content {
        padding-top: 12px;
        max-width: 320px;
      }
    }
  }
  .sa-stats {
    margin: {
      left: 0;
      right: 0;
      top: 25px;
    }
  }
}

/* Min width 1600px */
@media only screen and (min-width: 1600px) {
  .forfettario-welcome-card {
    .smartrate-card-content {
      padding: {
        left: 15px;
        right: 15px;
      }
    }
  }
  .sa-stats {
    margin: {
      left: 40px;
      right: 40px;
    }
  }
}
</style>
